module.exports = __webpack_public_path__ + "img/pro_1.1df03028.png";